import {useState} from 'react';
import './InputFormsForQuizes.scss';
import { closeInputForms, idAnswersCreateType2 } from '../../../adminSlice';

const AddInputFormsForAnswersType3  = (props) => {

            
        const [userInputContent, setUserInputContent] = useState('');
        const [userInputFeedback, setUserInputFeedback ]  = useState('');
        const [userInputValue, setUserInputValue] = useState('');

const { dispatch } = props;
  
 // CLICK OK
const onSend = () => {
        
        const item = {
            answer_content: userInputContent,
            
            answer_order: Number(userInputValue),

            question_id: props.adminState.selectedQuestion,
            //quiz_id: props.adminState.selectedQuize
            
        }
        console.log(item);
        dispatch(idAnswersCreateType2(item));  
}
// ENTER INPUT
const handleUserInputContent = (e) => {

            setUserInputContent(e.target.value);

}
const handleUserInputFeedback = (e) => {

            setUserInputFeedback(e.target.value);

}
const handleUserInputValue = (e) => {

            setUserInputValue(e.target.value);

}




// CLOSE FORM
const onClose = () => {

    dispatch(closeInputForms());

}

   

     
        return(
            <div className="InputFormsForQuizes">
                           


             <p>Создать новый ответ:</p>
             <form>
             
                 <label>
                     Текст бокса</label>
                 <textarea  onChange={handleUserInputContent} 
                 ></textarea>
                 


                 <label>
                     Порядковый номер</label>
                 <input id="value" type="text"  onChange={handleUserInputValue} 
                 />
                


                 



             </form>
             <button onClick={onSend}>OK</button>
             <button onClick={onClose}>Отмена</button>
            </div>
        )
     
       
     

        
    
}

export default AddInputFormsForAnswersType3;